import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

export default function MatrimonyNavbar() {
  const { user, isAdmin, adminName, adminViaSmabizz, logout } = useAuth();
  const location  = useLocation();
  const navigate  = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const isActive = (path) => location.pathname === path;
  const isLoggedIn = user || isAdmin;

  const handleLogout = async () => {
    setMenuOpen(false);
    if (adminViaSmabizz) {
      // SmaBizZ admin — invalidate Spring session
      window.location.href = '/spring/logout';
    } else {
      await logout();
      navigate('/login');
    }
  };

  const displayName = adminName || (user && user.name) || '';

  return (
    <nav className="m-navbar">
      <div className="m-navbar-inner">
        <Link to="/" className="m-navbar-brand" onClick={() => setMenuOpen(false)}>
          <span className="m-brand-icon">💑</span>
          <span className="m-brand-text">SmaBizZ <span className="m-brand-accent">Matrimony</span></span>
        </Link>

        <div className={`m-navbar-links${menuOpen ? ' open' : ''}`}>
          <Link to="/" className={`m-nav-link${isActive('/') ? ' active' : ''}`} onClick={() => setMenuOpen(false)}>
            🏠 Home
          </Link>
          <Link
            to="/profiles"
            className={`m-nav-link${location.pathname.startsWith('/profiles') ? ' active' : ''}`}
            onClick={() => setMenuOpen(false)}
          >
            👥 Browse Profiles
          </Link>

          {/* Guest links — hidden when any user is logged in */}
          {!isLoggedIn && (
            <Link to="/register" className="m-btn m-btn-outline m-btn-sm" onClick={() => setMenuOpen(false)}>
              🌹 Register Free
            </Link>
          )}
          {!isLoggedIn && (
            <Link to="/login" className="m-btn m-btn-primary m-btn-sm" onClick={() => setMenuOpen(false)}>
              🔐 Login
            </Link>
          )}

          {/* Regular user links */}
          {user && !isAdmin && (
            <Link
              to="/dashboard"
              className={`m-nav-link${isActive('/dashboard') ? ' active' : ''}`}
              onClick={() => setMenuOpen(false)}
            >
              👤 My Profile
            </Link>
          )}

          {/* Admin link */}
          {isAdmin && (
            <Link
              to="/admin"
              className={`m-nav-link${isActive('/admin') ? ' active' : ''}`}
              onClick={() => setMenuOpen(false)}
            >
              ⚙️ Admin
            </Link>
          )}

          {/* Admin/user identity + logout */}
          {isLoggedIn && (
            <div className="m-navbar-user">
              <span className="m-navbar-avatar">
                {(displayName || 'A').charAt(0).toUpperCase()}
              </span>
              <span className="m-navbar-username">
                {displayName}
                {isAdmin && <span className="m-admin-badge">Admin</span>}
              </span>
              <button
                className="m-btn m-btn-ghost m-btn-sm m-signout-btn"
                onClick={handleLogout}
                title="Sign Out"
              >
                🚪 Sign Out
              </button>
            </div>
          )}
        </div>

        <button className="m-hamburger" onClick={() => setMenuOpen(m => !m)} aria-label="Toggle menu">
          {menuOpen ? '✕' : '☰'}
        </button>
      </div>
    </nav>
  );
}
